import { createFileRoute } from '@tanstack/react-router';
import PrintLedger from 'src/components/0500_print_ledger/dystopia_rising';

export const Route = createFileRoute(
  '/$organizationSlug/events/$eventId/printLedger',
)({
  component: PrintLedger,
});
